import type { SVGProps } from "react";
import { ICON_PATHS } from "./iconPaths.js";

interface IconProps extends SVGProps<SVGSVGElement> {
  name: string;
  strokeWidth?: number;
}

export function Icon({ name, className = "", strokeWidth = 1.9, ...rest }: IconProps) {
  const path = ICON_PATHS[name];
  if (!path) return null;

  return (
    <svg
      className={`mmm-icon ${className}`.trim()}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {path}
    </svg>
  );
}
